import { CoreDataEntity } from '@barthauer/abc/core/data';

export class DataEntity extends CoreDataEntity {
  constructor(
    public readonly objectType: string | number,
    public readonly id: string,
    public readonly feature?: any,
    public readonly isInFlowDirection?: boolean
  ) {
    super(objectType, id);
  }
}

export class DataEntityInfo {
  constructor(
    public readonly entity: DataEntity,
    public category: string,
    public displayText: string,
    public commandsBadgeValue: Object,
    public commandsEnabled: Object
  ) {}
}

export enum FeatureGeometryType {
  Point = 0,
  Line = 1,
  Polygon = 2,
}
